import { useContext, useEffect, useState, useCallback } from "react";
import { SalvoContext } from "../contexts/SalvoContext";
import { getCompany } from "../API/companyApi";
import emitter from "../eventBus";

// TODO: Extract balance fetching to separate BalanceContext and use that instead.
export default function useBalance(enabled = true) {
    const { selectedCompany } = useContext(SalvoContext);

    const [balance, setBalance] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchBalance = useCallback(async () => {
        if (!enabled || !selectedCompany?.id) {
            setBalance(null);
            setLoading(false);
            return;
        }

        setLoading(true);
        setBalance(null);
        try {
            const company = (await getCompany(selectedCompany.id)).data;

            if (company.billingInfo?.billingEnabled) {
                setBalance(company.billingInfo.balance);
            }
            else if (company.trialPeriod) {
                setBalance(company.trialPeriod.remainingCredits);
            }
        }
        finally {
            setLoading(false);
        }
    }, [enabled, selectedCompany?.id]);

    useEffect(() => {
        if (!enabled) {
            setBalance(null);
            setLoading(false);
            return;
        }

        fetchBalance();

        emitter.on('refresh-balance', fetchBalance);
        return () => {
            emitter.off('refresh-balance', fetchBalance);
        };
    }, [enabled, fetchBalance]);

    return { balance, loading, fetchBalance };
}